import { compose, getContext } from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import { debounce } from 'lodash'
import {
  NightlyUpdateNights,
  NightlyUpdatePrice
} from 'src/constants/trackingEvents'
import {
  selectPropertyDetailsMapWithHome,
  selectSettingsMap
} from 'src/store/selectors/airDna'
import { updateSettings } from 'src/actions/airDna'
import { dispatchEvent as rawDispatchEvent } from 'src/helpers/tagManager'

const dispatchEvent = debounce(rawDispatchEvent, 2000)

const ChartControlsContainer = compose(
  injectIntl,
  getContext({
    stateKey: PropTypes.string.isRequired
  }),
  connect(
    (state, { stateKey }) => ({
      ...selectSettingsMap(state)[stateKey],
      ...selectPropertyDetailsMapWithHome(state)[stateKey]
    }),
    (dispatch, { stateKey }) => ({
      updateSetting: e => {
        switch (e.target.name) {
          case 'nightsPerMonth':
            dispatchEvent(NightlyUpdateNights)
            break
          case 'pricePerNight':
            dispatchEvent(NightlyUpdatePrice)
            break
          default:
            break
        }

        dispatch(
          updateSettings(stateKey, {
            [e.target.name]: e.target.value
          })
        )
      }
    })
  )
)

export default ChartControlsContainer
